import script from "./promotionBasic.vue?vue&type=script&lang=ts&setup=true"
export * from "./promotionBasic.vue?vue&type=script&lang=ts&setup=true"

import "./promotionBasic.vue?vue&type=style&index=0&id=4f0646ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0646ae"]])

export default __exports__